import classnames from "classnames";

interface Props {
  id: string;
  className: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  value: string | number;
  numberInput?: boolean;
  // True  for the input to be disabled
  disabled?: boolean;
}

export default function StandardInput(props: Props) {
  return (
    <input
      type={props.numberInput ? "number" : "text"}
      key={props.id}
      className={classnames(
        "text-input",
        props.className,
        "placeholder:tw-text-gray-5",
      )}
      placeholder={props.placeholder || ""}
      onChange={props.onChange}
      value={props.value}
      disabled={props.disabled}
      data-testid={`${props.id}-input`}
    />
  );
}
